const initialState = () => ({
    all: [],
});

const depositTicketReducer = (state = initialState(), action) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'DEPOSIT_TICKET_RECEIVED':
            newState.all = action.payload.sort((a, b) => {
                if (a.date > b.date ) return -1;
                if (a.date < b.date ) return 1;
                return 0;
            });
            return newState;
        case 'DEPOSIT_TICKET_CREATED':
            newState.all.push(action.payload);
            return newState;
        case 'DEPOSIT_TICKET_EDITED':
            newState.all.forEach((ticket, idx) => {
                if (ticket.id === action.payload.id) {
                    newState.all[idx] = {...action.payload };
                }
            });
            return newState;
        case 'DEPOSIT_TICKET_DELETED':
            newState.all.forEach((ticket, idx) => {
                if (ticket.id === action.payload) {
                    newState.all.splice(idx, 1);
                }
            });
            return newState;
        case 'DEPOSIT_TICKET_UPLOAD_PICTURES_SUCCESS':
            newState.all.forEach((ticket, idx) => {
                // [0] because all images are on same event
                if (parseInt(ticket.id) === parseInt(action.payload[0].data.deposit_ticket_id)) {
                    action.payload.forEach(row => {
                        newState.all[idx].pictures.push(row.data);
                    });
                }
            });
            return newState;
        case 'PICTURE_UPDATED':
            if (!action.payload.deposit_ticket_id) return state;
            newState.all.forEach((m, idx) => {
                if (m.id === action.payload.deposit_ticket_id) {
                    newState.all[idx].pictures.forEach((p, m_idx) => {
                        if (newState.all[idx].pictures[m_idx].id === action.payload.id) {
                            newState.all[idx].pictures[m_idx].comment = action.payload.comment;
                        }
                    });
                }
            });
            return newState;
        case 'PICTURE_REMOVE_SUCCESS':
            if (!action.payload.deposit_ticket_id) return state;
            newState.all.forEach((m, idx) => {
                if (m.id === action.payload.deposit_ticket_id) {
                    newState.all[idx].pictures.forEach((p, m_idx) => {
                        if (newState.all[idx].pictures[m_idx].id === action.payload.id) {
                            newState.all[idx].pictures.splice(m_idx, 1);
                        }
                    });
                }
            });
            return newState;
        case 'LOGOUT':
            return Object.assign({}, initialState());
        default:
            return state;
    }
};

export default depositTicketReducer;
